"use client";

import { useState } from "react";

type CiteCopyButtonProps = {
  text: string;
};

/**
 * CiteCopyButton Component - Client-side
 * 
 * Gestisce solo la funzionalità di copia, che richiede navigator.clipboard (solo client).
 */
export function CiteCopyButton({ text }: CiteCopyButtonProps) {
  const [copied, setCopied] = useState(false);

  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      console.error("Failed to copy text:", error);
    }
  };

  return (
    <button onClick={onCopy} className="verify-link" type="button">
      {copied ? "Copiato" : "Copia"}
    </button>
  );
}

